module.exports = __webpack_public_path__ + "media/images/promo/championship/03-4af5f28f5f911159c646cb87541ef6aa.png";